module.exports = __webpack_public_path__ + "static/sport/swiper-4.49ffd9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport4/swiper-4.png
// module id = 6WKB
// module chunks = 0